module.exports = __webpack_public_path__ + "img/confetti.77c78a86.gif";